




import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { DistributorModel, DistributorsClient } from "@/diamond-support-api";

@Component
export default class Associates extends Vue {
  distributorDetail: DistributorModel | null = null;
  distributorApi = new DistributorsClient();

  @Getter("distributorId", { namespace: "distributor" }) distributorId: any;

  async mounted() {

    if (this.distributorId) {
      this.$router
        .push({
          path: `/associates/${this.distributorId}/detail`,
        })
        .catch(() => {});
    }
  }
}
